import React from "react";

import { createGenerateClassName, StylesProvider } from "@mui/styles";

import { OnboardingStage } from "../../../../../../models/onboarding.stage";
import DestinationPage from "./Destination";
import ExceptionCodes from "./ExceptionCodes";
import ExceptionLocationCode from "./ExceptionLocationCode";
import Item from "./Item";
import ItemTypes from "./ItemTypes";
import MethodOfPreparation from "./MethodOfPreparation";
import ModeType from "./ModeType";
import Room from "./Room";
import SpecialInstructions from "./SpecialInstructions";

const generateClassName = createGenerateClassName({
  productionPrefix: "invt-",
  seed: "inventory-page",
});

enum Pages {
  ITEM = "Item List",
  LOCATION = "Location",
  PACKAGING = "Packaging type",
  PREPARATION = "Method of preparation",
  EXCEPTION = "Exception codes",
  EXCEPTION_LOCATION = "Exception location code",
  MODE = "Mode type",
  SPECIAL_INSTRUCTIONS = "Item instructions",
  DESTINATION = "Item destination",
}

interface Props {
  tabName: string;
  onboardingStage?: OnboardingStage;
  refetchIsoCertificate: () => void;
  permission?: {
    edit: boolean,
    create: boolean,
  }
}

const InventoryPage = ({ tabName, onboardingStage, refetchIsoCertificate, permission }: Props) => {
  const setCurrentComponent = () => {
    switch (tabName) {
      case Pages.ITEM:
        return (
          <Item permission={permission} onboardingStage={onboardingStage} refetchIsoCertificate={refetchIsoCertificate} />
        );
      case Pages.LOCATION:
        return <Room permission={permission} />;
      case Pages.PACKAGING:
        return <ItemTypes permission={permission}  />;
      case Pages.PREPARATION:
        return <MethodOfPreparation permission={permission} />;
      case Pages.EXCEPTION:
        return <ExceptionCodes permission={permission} />;
      case Pages.EXCEPTION_LOCATION:
        return <ExceptionLocationCode permission={permission} />;
      case Pages.MODE:
        return <ModeType permission={permission} />;
      case Pages.SPECIAL_INSTRUCTIONS:
        return <SpecialInstructions permission={permission} />;
      case Pages.DESTINATION:
        return <DestinationPage permission={permission} />;
      default:
        return null;
    }
  };

  return (
    <StylesProvider generateClassName={generateClassName}>
      <div className="inventory-tabs">{setCurrentComponent()}</div>
    </StylesProvider>
  );
};

export default InventoryPage;
